import * as React from 'react'
import * as styles from './Facet.module.scss'
import * as cn from 'classnames'
import { StorefrontCollectionFacet } from '@utils'

// TODO(AVWebStorefront-1435): This is a temporary hack we need to do because
// Merch has been using facetText for different reasons.
const AMAZON_CHANNELS = 'Amazon Channels'
const PRIME_CHANNELS = 'Prime Video Channels'
const NEW_LOGO_PATH = 'https://m.media-amazon.com/images/G/01/digital/video/global/prime-logo-large-v4._CB509553088_.png'
const OLD_LOGO_RE = /.*(prime-logo-large-v2._V1_.png)/ig


interface FacetProps extends StorefrontCollectionFacet {
  className?: string
}

const validateText = (text: string) => {
  return text &&
  text.trim() !== "" &&
  text !== AMAZON_CHANNELS &&
  text !== PRIME_CHANNELS && text
}

const getProcessedFacetText = (props: FacetProps) => {
  const text = validateText(props.text) || validateText(props.alternateText)
  return text ?
    <span className={cn(styles.facetText, {
      [styles.whiteUppercase]: props.style === 'WhiteUppercase',
      [styles.orangeTitlecase]: props.style === 'OrangeTitlecase'
    })}>
      {text}
    </span> : null
}

const PrimeFacet = (props: FacetProps) => (
  <div className={cn(styles.facet, styles.primeFacet, props.className)}>
    <span className={styles.FacetImage}>
      <img
        src={NEW_LOGO_PATH}
        alt={props.alternateText}
      />
    </span>
  </div>
)

const DefaultFacet = (props: FacetProps) => {
  if (!props.text && !props.image && !props.alternateText) {
    return null
  }
  return (
    <div className={cn(styles.facet, props.className)}>
      {(!props.image || props.style === 'OrangeTitlecase') && getProcessedFacetText(props)}
      <span className={styles.FacetImage}>
        {
          props.image
            && (<img
              src={props.image.replace(OLD_LOGO_RE, NEW_LOGO_PATH)}
              alt={props.alternateText}
            />)
        }
      </span>
    </div>
  )
}

const Facet = (props: FacetProps) => {
  if (!props || props.facetType === 'NONE') {
    return null
  }
  if (props.facetType === 'PRIME') {
    return (<PrimeFacet {...props} />)
  }
  return (<DefaultFacet {...props} />)
}

export default Facet
